export const SET_CONT_WIDTH = 'SET_CONT_WIDTH';
export const SET_DRAGGABLE = 'SET_DRAGGABLE';
export const SET_TRANSLATE_X = 'SET_TRANSLATE_X';
export const SET_SHOWN_PERCENT = 'SET_SHOWN_PERCENT';
export const SET_CURSOR_POSITION = 'SET_CURSOR_POSITION';
export const SET_PREVIEW_VISIBLE = 'SET_PREVIEW_VISIBLE';
